import { GET } from '../request'

export const getAlumnoList = ({ nombre }) =>
  GET('/api/core/alumnos/alumno/list/search', { filtro: nombre })

export const getAlumnosSeguimento = ({ mes, centro }) =>
  GET('/api/core/alumnos/alumno/list/new', { mes, centro })

export const getValoracionesAlumnos = ({ mes }) =>
  GET('/api/core/alumnos/valoracion-alumnos/list', { mes })
